import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const unassignAccountEntitlementsSlice = getBulkActionSlice(
    'unassignAccountEntitlementsResult',
);

export const selectUnassignAccountEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.unassignAccountEntitlementsResult.shown;

export const selectUnassignAccountEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.unassignAccountEntitlementsResult.uuid;

export const selectUnassignAccountEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.unassignAccountEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = unassignAccountEntitlementsSlice.actions;
